module.exports = __webpack_public_path__ + "img/Blockdit-Icon.03a072dd.svg";